<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'when')">{{ schema.fields.when.label }}</th>
        <th v-if="canSee(schema, 'who')">{{ schema.fields.who.label }}</th>
        <th v-if="canSee(schema, 'note')">{{ schema.fields.note.label }}</th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'when')">
          <o-widget-wrapper
            :schema="schema"
            name="when"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].when"
              name="when"
              v-bind="schema.fields.when"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'who')">
          <o-widget-wrapper
            :schema="schema"
            name="who"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              flat
              clearable
              v-model="items[index].who"
              :items="optionUserItems"
              text-field="username"
              value-field="id"
              :validator="validators.$each[index][schema.fields.who.name]"
              :loading="optionUserWorking"
              name="who"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              v-bind="schema.fields.who"
              :form-state="formState"
            ></o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'note')">
          <o-widget-wrapper
            :schema="schema"
            name="note"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].note"
              :form-state="formState"
              name="note"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.note"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  name: "ExtraMaintenanceNoteFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("ExtraMaintenanceNote"),
    CreateCodeTableFetchMixin(["User"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ExtraMaintenanceNote,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.ExtraMaintenanceNote),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>